// @flow
import React, { FC, useState } from 'react';

import translate from '../../translate';

import ActiveVersion from './ActiveVersion';
import ActionsVersion from './ActionsVersion';
import Grid, { GridItem } from '../../components/Grid';
import TextField from '../../components/TextField';
import EmailEditorBlock from './EmailEditorBlock';

export interface VersionFormProps {
    data: any;
    disableEdit: boolean;
    changeValue: any;
    errors: any;
    newEmailTemplate: any;
    emailTemplateData: any;
    saveVersion: any;
    activateVersion: any;
    testVersion: any;
    deleteVersion: any;
    updateSelectVersion: any;
    changeVersionValue: any;
}
const VersionForm: FC<VersionFormProps> = (props) => {
    const changeJsonValue = (value: any, dataKey: any, error: any) => {
        try {
            const parseResult = JSON.parse(value);
            props.changeValue(value, dataKey, error);
        } catch (e) {
            props.changeValue(value, dataKey, true);
        }
    };

    const onBlur = () => {
        if (!props.errors?.test_data && props.data?.test_data) {
            props.changeValue(JSON.stringify(JSON.parse(props.data.test_data), null, '\t'), 'test_data', false);
        }
    };

    const multipleVersions = !props.newEmailTemplate && (props.emailTemplateData?.TEMPLATE?.versions?.length || 0) > 1;

    return (
        <Grid>
            <GridItem cols={12}>
                <ActionsVersion
                    data={props.data}
                    disableEdit={props.disableEdit}
                    newEmailTemplate={props.newEmailTemplate}
                    saveVersion={props.saveVersion}
                    activateVersion={props.activateVersion}
                    deleteVersion={props.deleteVersion}
                    testVersion={props.testVersion}
                    changeVersionValue={props.changeVersionValue}
                />
            </GridItem>
            {multipleVersions && (
                <GridItem cols={12}>
                    <ActiveVersion
                        data={props.data}
                        emailTemplateData={props.emailTemplateData}
                        updateSelectVersion={props.updateSelectVersion}
                    />
                </GridItem>
            )}
            <GridItem cols={12}>
                <TextField
                    label={translate('emailTemplateDetail.name')}
                    value={props.data.name}
                    onChange={(value: any, error: boolean): any => props.changeValue(value, 'name', error)}
                    name="name"
                    error={props.errors.name}
                    disabled={props.disableEdit}
                    fullWidth
                    required
                />
            </GridItem>
            <GridItem cols={12}>
                <TextField
                    label={translate('emailTemplateDetail.subject')}
                    value={props.data.subject}
                    onChange={(value: any, error: boolean): any => props.changeValue(value, 'subject', error)}
                    name="subject"
                    error={props.errors.subject}
                    disabled={props.disableEdit}
                    fullWidth
                    required
                />
            </GridItem>
            <GridItem cols={12}>
                <TextField
                    multiline
                    label={translate('emailTemplateDetail.test_data')}
                    value={props.data.test_data}
                    onChange={(value: any, error: boolean): any => changeJsonValue(value, 'test_data', error)}
                    name="test_data"
                    error={props.errors.test_data}
                    disabled={props.disableEdit}
                    fullWidth
                    onBlur={onBlur}
                />
            </GridItem>
        </Grid>
    );
};

export default VersionForm;
